<template>
  <div>
    <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="cooperation-desc design_box">
        <div class="cooperation-desc-body cooperation-desc-type-1">
          <div v-for="(item,index) in property.list" :key="index" class="cooperation-desc-list" :style="{background:'url(' + item + ') 100%',backgroundSize:'cover',backgroundPosition:'center'}"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    },
    created() {
    }
  };
</script>



